<script setup lang="ts">
  import type { DocumentRevision } from '@/entities/Document';
  import { DocumentList } from '@/widgets/document-actions';
  import { useDocumentUploadModals } from '../lib/useDocumentUploadModals';

  const { openExternalUploadModal, openReplaceModal } = useDocumentUploadModals();

  const handleOpenExternalUpload = () => {
    openExternalUploadModal();
  };

  const handleReplaceDocument = (revision: DocumentRevision) => {
    openReplaceModal(revision);
  };
</script>

<template>
  <DocumentList
    @open-external-upload="handleOpenExternalUpload"
    @replace-document="handleReplaceDocument"
  />
</template>
